<template>
    <ui-modal name="feedback-modal"
        icon-circle>
        <template>
            <i class="svg-feedback-user">
                <svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.2568 27C20.2568 23.4087 15.9465 20.5 10.6284 20.5C5.31032 20.5 1 23.4087 1 27M23.1903 4.5295C23.7866 5.13298 24.2596 5.84951 24.5823 6.63816C24.905 7.42682 25.0711 8.27213 25.0711 9.12581C25.0711 9.97949 24.905 10.8248 24.5823 11.6135C24.2596 12.4021 23.7866 13.1186 23.1903 13.7221M26.6758 1C27.7297 2.06687 28.5657 3.33354 29.136 4.72764C29.7064 6.12175 30 7.61598 30 9.125C30 10.634 29.7064 12.1283 29.136 13.5224C28.5657 14.9165 27.7297 16.1831 26.6758 17.25M10.6284 15.625C8.92601 15.625 7.29332 14.9402 6.08954 13.7212C4.88575 12.5022 4.20947 10.8489 4.20947 9.125C4.20947 7.40109 4.88575 5.74779 6.08954 4.52881C7.29332 3.30982 8.92601 2.625 10.6284 2.625C12.3308 2.625 13.9635 3.30982 15.1673 4.52881C16.3711 5.74779 17.0474 7.40109 17.0474 9.125C17.0474 10.8489 16.3711 12.5022 15.1673 13.7212C13.9635 14.9402 12.3308 15.625 10.6284 15.625Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </i>

            <i class="far fa-times" @click="close" />

            <section class="content-feedback-modal">
                <span class="content-feedback-modal-title">Deixe aqui o seu feedback</span>

                <div class="content-feedback-modal-type" v-for="filter in filters" :key="filter.id">
                    <ui-select2 v-model="filter.params.value"
                        :data="filter.options"
                        :label="filter.label"
                        :item-label="filter.itemLabel"
                        :disabled="filter.disabled"
                        :return-value="filter.returnValue"
                        :search="filter.searchAble"
                        design="br-all"
                        size="md" />
                </div>

                <div class="content-feedback-modal-text-area">
                    <div class="text-area">
                        <ui-textarea label="Deixe sua mensagem abaixo:"
                            placeholder="Digite aqui sua mensagem..."
                            v-model="sendMessage" />
                    </div>
                </div>

                <div class="content-feedback-modal-checkbox"
                    v-for="(filter, index) in filtersCheckbox" :key="index">
                    <span class="title">{{ filter.title }}</span>

                    <ui-checkbox v-for="(item, i) in filter.items"
                        :key="i"
                        :id="i"
                        :label="item.label"
                        :checked.sync="item.checked"
                        @input="sortByHandler($event, i)"
                        design="xs success circle" />
                </div>
            </section>
        </template>

        <template #footer>
            <div class="footer">
                <span @click="close">Cancelar</span>

                <ui-button design="success md"
                    :disabled="!canSubmit"
                    @click="sendFeedback">
                    <span v-show="!loader.load">Enviar feedback</span>
                    <ui-load-indicator v-show="loader.load" :h="30" />
                </ui-button>
            </div>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiSelect2, uiTextarea, uiCheckbox } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'
	import uiLoadIndicator from '@/components/ui/load-indicator'
	import { helpersMixin } from '@/mixins'
    import rulesMixin from './mixins/rules'
    import servicesMixin from './services/methods'

    const filter = [
        {
            label: 'Escolha o tipo de feedback que você deseja enviar:',
            itemLabel: 'item',
            searchAble: false,
            returnValue: 'value',
            options: [
                { item: 'Lentidão ou Instabilidade', value: 'slowness-instability', id: 0 },
                { item: 'Usabilidade', value: 'usability', id: 1 },
                { item: 'Problemas ou Bugs', value: 'problems-bugs', id: 2 },
                { item: 'Melhorias', value: 'improvements', id: 3 },
                { item: 'Elogios', value: 'praise', id: 4 },
            ],
            params: {
                name: 'feedback',
                value: null
            }
        }
    ]

    const defaultLoader = () => ({
        load: false,
    })

    export default {
        name: 'ui-feedback-modal',

        components: {
            uiModal,
            uiSelect2,
            uiTextarea,
            uiCheckbox,
            uiButton,
            uiLoadIndicator
        },

		mixins: [helpersMixin, rulesMixin, servicesMixin],

        data() {
            return {
                sendMessage: '',
                filters: [ ...filter ],
                loader: { ...defaultLoader() },
                satisfied: null,
                buttonSatisfied: null,
                filtersCheckbox: [
                    {
                        title: 'Você está satisfeito com a sua experiência?',
                        name: 'checked-feedback',
                        items: [
                            {
                                label: 'Sim',
                                checked: false,
                                value: 1
                            },
                            {
                                label: 'Não',
                                checked: false,
                                value: 0
                            }
                        ],
                        selected: { value: '' }
                    }
                ]
            }
        },

        mounted() {
            this.$root.$on('modal-open-feedback-modal', () => {})
        },

        beforeDestroy() {
            this.$root.$off('modal-open-feedback-modal')
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>